<template>
	<button
		class="burger"
		:class="{ active }"
		aria-label="Abrir menu"
		@click="$emit('toggle')"
	>
		<span></span><span></span><span></span>
	</button>
</template>

<script>
export default {
	name: 'BurgerMenu',
	props: {
		active: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['toggle'],
};
</script>

<style scoped>
.burger {
	display: none;
	flex-direction: column;
	gap: 5px;
	background: none;
	border: none;
	cursor: pointer;
	padding: 8px;
	z-index: 60;
}
.burger span {
	width: 24px;
	height: 1.5px;
	background: var(--ink);
	display: block;
	transition: all 0.3s ease;
}
.burger.active span:nth-child(1) {
	transform: translateY(6.5px) rotate(45deg);
}
.burger.active span:nth-child(2) {
	opacity: 0;
}
.burger.active span:nth-child(3) {
	transform: translateY(-6.5px) rotate(-45deg);
}

@media (max-width: 900px) {
	.burger {
		display: flex;
	}
}
</style>
